<template>
  <div>
    <UIProgressCircular v-show="!dataLoaded" />

    <div v-show="dataLoaded" class="mt-4">
      <ButtonGoTo
        :location="getFormTemplatePageLocation(formTemplate)"
        title="К мероприятию" class="mb-4 px-2"
      />

      <v-card
        class="pa-4 mx-0 base-card d-flex row justify-center align-center mb-4"

        :class="{'justify-space-between': !isXs}"
      >
        <h3 class="text-center">
          {{ formTemplate.name }}
        </h3>
        <div class="d-flex align-center">
          <v-chip-group class="base-chip-group">
            <v-chip v-for="filter in filtersTable.filter((el) => el.value !== null && el.value !== undefined) " :key="`${filter.fieldTypeId}-${filter.formTemplateFieldId}chip`" class="base-chip" variant="outlined" close :ripple="false" :title="filter.fieldName" @click:close="clearFilter(filter)">
              {{ filter.value ? getCurrentValueForDisplay(getDisplayList(filter)) : '' }}
            </v-chip>
          </v-chip-group>
          <v-btn class="mr-4" variant="plain" icon style="color: black;" @click="filterDialog = true">
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>

          <ButtonOutlineSmall
            title="Скачать отчет" icon="file-text"
            @click="openReportTemplatesListForDownloadDialog"
          />
        </div>
      </v-card>

      <v-card ref="mainCard" class="base-card pb-4 px-4">
        <!-- <p v-if="!listSortedBySentTime.length" class="text-center pt-4">
          Нет данных
        </p> -->
        <v-data-table
          v-if="!isXs"
          ref="table"
          v-scroll.self="tableScroll"
          class="elevation-0"
          :class="isXs ? 'mobile-table' : 'base-table'"
          :loading="tableLoading"
          :headers="tableHeaders"
          :items="listSortedBySentTime"
          :items-per-page="-1"
          loading-text="Загрузка" no-data-text="Нет данных" no-results-text="Не найдено"
          hide-default-footer fixed-header
        >
          <template #item="{ item }">
            <tr>
              <td
                v-for="header of tableHeaders" :key="header.value"
                :class="`text-${header.align}`"
              >
                <span v-if="!['actions', 'status'].includes(header.value) && header.fieldTypeId !== '8'">{{ item[header.value] }}</span>
                <span v-if="header.fieldTypeId === '8' && item[header.value] === 'Да'">
                  <v-icon
                    class="mr-4 uikit-icon file-text show-btn size-20" title="Файлы"
                    @click="openDownloadFilesDialog(item, header.value)"
                  />
                </span>

                <div
                  v-if="header.value === 'actions'"
                  class="d-flex justify-center align-center"
                  style="gap: 16px"
                >
                  <v-icon
                    v-if="isOperatorRoles"
                    class="uikit-icon edit-icon edit-btn size-20"
                    title="Редактировать"
                    @click="goToForm(item)"
                  />

                  <v-progress-circular
                    v-if="badgeLoading && currentLoadingBadgeId === item.id"
                    :width="2"
                    :size="20"
                    color="primary"
                    indeterminate
                  />
                  <v-icon
                    v-else-if="item.status.isFinal"
                    class="uikit-icon badge edit-btn size-20"
                    title="Печать бейджа"
                    @click="printBadge(item)"
                  />

                  <v-icon
                    v-if="isAdmin"
                    class="uikit-icon trash remove-btn size-20"
                    title="Удалить"
                    @click="remove(item)"
                  />
                </div>

                <div
                  v-if="header.value === 'check'"
                  class="d-flex justify-center align-center"
                >
                  <v-checkbox
                    v-if="!setIsSeenLoadingList.includes(item.id)"
                    v-model="item.isSeen"
                    color="primary"
                    class="ma-0 pa-0 checkbox_margin-right_0"
                    hide-details
                    @change="setIsSeen($event, item)"
                  />
                  <v-progress-circular
                    v-else
                    :width="2"
                    :size="20"
                    color="primary"
                    indeterminate
                  />
                </div>

                <MenuButton
                  v-if="header.value === 'status'"
                  :name="item.status.name"
                  :filled-form-id="item.id"
                  @changeFilledFormStatus="changeFilledFormStatus($event, item)"
                  @sendToRevision="openSendToRevisionDialog($event, item)"
                />
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <div>Таблица пуста</div>
          </template>
        </v-data-table>

        <v-list v-if="isXs" ref="list" class="px-4 pt-0 transparent overflow-auto">
          <v-row class="my-0 mt-4">
            <v-col
              v-for="(item) of listSortedBySentTime" :key="item.id"
              cols="12"
              class="pt-0 d-flex" :class="$vuetify.breakpoint.xs ? 'px-0' : ''"
            >
              <v-card
                class="base-card pb-4 px-4 w-full d-flex flex-column justify-space-between"
                :ripple="false"
              >
                <v-card-text>
                  <div class="d-flex justify-space-between mb-2">
                    <v-menu bottom left offset-y>
                      <template #activator="{ on, attrs }">
                        <v-icon
                          color="primary"
                          class="cursor-pointer mr-2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div class="pa-2" style="background-color: #fff">
                        <span><strong>id:</strong> {{ item.id }}</span> <br>
                        <span><strong>Дата отправки:</strong> {{ item.sentTime || '-' }}</span><br>
                      </div>
                    </v-menu>

                    <div>
                      <v-icon
                        v-if="isAdmin"
                        class="uikit-icon edit-icon edit-btn size-20 mr-2"
                        title="Редактировать"
                        @click="goToForm(item)"
                      />
                      <v-progress-circular
                        v-if="badgeLoading && currentLoadingBadgeId === item.id"
                        :width="2"
                        :size="20"
                        color="primary"
                        indeterminate
                      />
                      <v-icon
                        v-else-if="item.status.isFinal"
                        class="uikit-icon badge edit-btn size-20 mr-2"
                        title="Печать бейджа"
                        @click="printBadge(item)"
                      />
                      <v-icon
                        v-if="isAdmin"
                        class="uikit-icon trash remove-btn size-20"
                        title="Удалить"
                        @click="remove(item)"
                      />
                    </div>
                  </div>

                  <div v-for="header of tableHeaders" :key="header.value">
                    <span
                      v-if="!['actions', 'status', 'id', 'sentTime', 'check'].includes(header.value) && header.fieldTypeId !== '8'"
                    >
                      <strong>{{ header.text }}:</strong> {{ item[header.value] || '-' }}
                    </span>
                    <span v-if="header.fieldTypeId === '8' && item[header.value] === 'Да'">
                      <strong>{{ header.text }}:</strong>
                      <v-icon
                        class="mr-4 uikit-icon file-text show-btn size-20" title="Файлы"
                        @click="openDownloadFilesDialog(item, header.value)"
                      />
                    </span>
                  </div>
                </v-card-text>

                <v-divider />

                <v-card-actions class="d-flex row justify-space-between mt-2">
                  <div class="mb-2">
                    <v-checkbox
                      v-if="!setIsSeenLoadingList.includes(item.id)"
                      v-model="item.isSeen"
                      label="Скачано"
                      color="primary"
                      dense
                      class="ma-0 pa-0 checkbox_margin-right_0"
                      hide-details
                      @change="setIsSeen($event, item)"
                    />
                    <v-progress-circular
                      v-else
                      :width="1"
                      :size="15"
                      color="primary"
                      indeterminate
                    />
                  </div>

                  <MenuButton
                    :name="item.status.name"
                    :filled-form-id="item.id"
                    @changeFilledFormStatus="changeFilledFormStatus($event, item)"
                    @sendToRevision="openSendToRevisionDialog($event, item)"
                  />
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-list>
      </v-card>
    </div>

    <DownloadFilesDialog
      :field-value-id="selectedFieldValueId"
      :dialog="downloadFilesDialog"
      @close="closeDownloadFilesDialog"
    />

    <SendToRevisionDialog
      :dialog="sendToRevisionDialog"
      @sendToRevision="changeFilledFormStatus(selectedSendToRevisionStatus, selectedSendToRevisionItem, $event)"
      @closeModal="closeSendToRevisionDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="removeLoading"
      :message="`Вы уверены, что вы хотите это удалить?`"
      @confirm="removeFilledForm"
      @closeConfirmModal="closeConfirmDialog"
    />

    <ChoosingReportTemplatesListForDownloadDialog
      :dialog="isOpenedReportTemplatesListForDownloadDialog"
      :selected-item="formTemplate"
      @closeModal="closeChoosingReportTemplatesListForDownloadDialog"
    />
    <FiltersDialog
      :dialog.sync="filterDialog"
      :filters="filtersTable"
      :is-xs="isXs"
      @update:filter="handleFilterUpdateFromDialog"
      @apply="applyFilter"
    />
  </div>
</template>

<script>
import {
  cloneDeep,
  debounce,
} from 'lodash'
import { FieldList, FormTemplate } from '@/models'
import { filledFormApi, formTemplateApi, badgeApi, dropDownListContentApi } from '@/api'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog'
import UIProgressCircular from '@/ui/progress/UIProgressCircular'
import { mapGetters } from 'vuex'
import DownloadFilesDialog from '@/components/Spm/Events/FilledFormValuePage/dialogs/DownloadFilesDialog'
import MenuButton from '@/components/Spm/Events/FilledFormValuePage/elements/MenuButton'
import { FieldType } from '@/enums'
import ButtonOutlineSmall from '@/featureSlicedDesign/shared/ui/ButtonOutlineSmall'
import SendToRevisionDialog from '@/components/Spm/Events/FilledFormValuePage/dialogs/SendToRevisionDialog'
import { formatISODateTimeToText, formatTextToISODateTime } from '@/scripts/formatDate'
import printJS from 'print-js'
import { FieldTypeId } from '@/enums/fieldType'
import { toText } from '@/scripts/blob'
import ChoosingReportTemplatesListForDownloadDialog
  from '@/components/Spm/Events/FormTemplatePage/dialogs/ChoosingReportTemplatesListForDownloadDialog'
import ButtonGoTo from '@/featureSlicedDesign/features/ButtonGoTo'
import { getFormTemplatePageLocation } from '@/router/utils'
import FiltersDialog from '@/components/Spm/Events/FilledFormValuePage/dialogs/FiltersDialog.vue'
import { getCurrentValueForDisplay, getCurrentValueForFilter } from '../../../scripts/formatData'

export default {
  name: 'FilledFormValue',
  metaInfo: { title: 'Заполненные данные' },

  components: {
    ChoosingReportTemplatesListForDownloadDialog,
    ButtonGoTo,
    SendToRevisionDialog,
    ButtonOutlineSmall,
    MenuButton,
    DownloadFilesDialog,
    UIProgressCircular,
    ConfirmDialog,
    FiltersDialog,
  },
  beforeRouteLeave(to, from, next) {
    this.saveTableState()
    const scrollTop = this.$refs.table?.$el?.scrollTop || 0
    sessionStorage.setItem(`filledFormScroll_${this.$route.params.id}`, String(scrollTop))

    sessionStorage.setItem('pageExitedNormally', 'true')
    next()
  },
  async created() {
    const exitedNormally = sessionStorage.getItem('pageExitedNormally') === 'true'

    if (!exitedNormally) {
      sessionStorage.removeItem(`filledFormState_${this.$route.params.id}`)
      sessionStorage.removeItem(`filledFormScroll_${this.$route.params.id}`)
    } else {
      sessionStorage.removeItem('pageExitedNormally')
    }

    await this.getFormTemplate()

    const restored = this.restoreTableState()
    if (restored) {
      this.dataLoaded = true
      this.$nextTick(() => {
        this.restoreScroll()
      })
    } else {
      await this.getFilledFormList()
      await this.getFilterDropDownLists(this.filtersTable)
      this.dataLoaded = true
    }
  },

  mounted() {
    window.addEventListener('resize', this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener('resize', this.setTableHeight)
  },

  data: () => ({
    list: [],
    fields: new FieldList(),
    formTemplate: new FormTemplate(),
    badgeLoading: false,
    currentLoadingBadgeId: null,
    filterDialog: false,
    filtersTable: [],
    pageNumber: 0,
    lastPage: false,
    total: 0,
    delay: false,
    restoredFromCache: false,

    tableHeaders: [
      { text: 'id', value: 'id', fieldTypeId: '', sortable: false, align: 'center' },
      { text: 'Дата отправки', value: 'sentTime', fieldTypeId: '', sortable: false, align: 'center' },
      { text: 'Скачано', value: 'check', fieldTypeId: '', sortable: false, align: 'center' },
      { text: 'Действия', value: 'actions', fieldTypeId: '', sortable: false, align: 'center' },
      { text: 'Статус', value: 'status', fieldTypeId: '', sortable: false, align: 'start' },
    ],

    selectedItem: null,
    selectedFieldValueId: null,
    selectedSendToRevisionItem: null,
    selectedSendToRevisionStatus: null,
    downloadFilesDialog: false,
    confirmDialog: false,
    dialog: false,
    sendToRevisionDialog: false,

    isShowMode: false,

    tableLoading: false,
    saveBtnLoading: false,
    removeLoading: false,
    dataLoaded: false,
    setIsSeenLoadingList: [],
    isOpenedReportTemplatesListForDownloadDialog: false,

    newList: [],
  }),

  computed: {
    ...mapGetters('breakpoint', ['isXs']),
    ...mapGetters('settings', ['isShowFullNews']),
    ...mapGetters('user', ['isOperatorRoles', 'isAdmin']),

    listSortedBySentTime() {
      return this.list.sort((a, b) => new Date(formatTextToISODateTime(b.sentTime))
        - new Date(formatTextToISODateTime(a.sentTime)))
    },

  },

  methods: {
    getFormTemplatePageLocation,
    getCurrentValueForDisplay,
    getCurrentValueForFilter,
    openDownloadFilesDialog(item, headerValue) {
      this.downloadFilesDialog = true
      this.selectedFieldValueId = item.fieldValueId[headerValue]
    },

    openSendToRevisionDialog(statusId, item) {
      this.sendToRevisionDialog = true
      this.selectedSendToRevisionItem = item
      this.selectedSendToRevisionStatus = statusId
    },
    getDisplayList(filter) {
      if (filter.fieldTypeId === FieldTypeId.Autocomplete) {
        return filter.list?.find((el) => el.id === Number(filter.value))?.name
      } return filter.value
    },
    handleFilterUpdate(filter, val) {
      this.filtersTable = this.filtersTable.map((f) => {
        if (
          f.formTemplateFieldId === filter.formTemplateFieldId
        && f.fieldTypeId === filter.fieldTypeId
        ) {
          return { ...f, value: val }
        }
        return f
      })
    },
    handleFilterUpdateFromDialog(updatedFilter) {
      this.filtersTable = this.filtersTable.map((filter) => {
        if (
          filter.formTemplateFieldId === updatedFilter.formTemplateFieldId
          && filter.fieldTypeId === updatedFilter.fieldTypeId
        ) {
          return { ...filter, value: updatedFilter.value }
        }
        return filter
      })
    },

    async applyFilter() {
      this.filterDialog = false
      this.updateFilledFormList()
    },
    async clearFilter(clearFilter) {
      this.filtersTable = this.filtersTable.map((filter) => {
        if (
          filter.fieldTypeId === clearFilter.fieldTypeId
        && filter.formTemplateFieldId === clearFilter.formTemplateFieldId
        ) {
          return { ...filter, value: null }
        }
        return filter
      })
      this.updateFilledFormList()
    },

    async getFilterDropDownLists(filters) {
      try {
        const autocompleteFilterList = filters.filter(
          (el) => el.fieldTypeId === FieldTypeId.Autocomplete,
        )

        if (!autocompleteFilterList.length) return

        const dropDownList = await Promise.allSettled(
          autocompleteFilterList.map((el) => dropDownListContentApi.findAllByDropDownListId(el.formTemplateFieldId)),
        )

        const dropDownWithErrors = []

        for (let i = 0; i < autocompleteFilterList.length; i++) {
          if (dropDownList[i].status === 'fulfilled' && dropDownList[i].value) {
            const filterIndex = filters.findIndex(
              (filter) => filter.fieldTypeId === autocompleteFilterList[i].fieldTypeId
            && filter.formTemplateFieldId === autocompleteFilterList[i].formTemplateFieldId,
            )

            if (filterIndex !== -1) {
              this.$set(filters, filterIndex, {
                ...filters[filterIndex],
                list: dropDownList[i].value,
              })
            }
          } else {
            // eslint-disable-next-line no-unused-expressions
            dropDownWithErrors.push(this.fields.list.find(
              (el) => el.fieldType.id === autocompleteFilterList[i].fieldTypeId
            && el.id === autocompleteFilterList[i].formTemplateFieldId,
            ))?.name
          }
        }

        if (dropDownWithErrors.length) {
          throw new Error(
            `Не удалось получить следующие справочники: ${dropDownWithErrors.join(', ')}`,
          )
        }
      } catch (error) {
        console.error('Ошибка загрузки справочников:', error)
        this.$toastr('error', error.message || 'Не удалось загрузить некоторые справочники', 'Ошибка')
      }
    },

    async setIsSeen(event, item) {
      try {
        this.setIsSeenLoadingList.push(item.id)
        await filledFormApi.setIsSeen(item.id, event)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка записи информации о проверке')
        // eslint-disable-next-line no-param-reassign
        item.isSeen = !event
      } finally {
        this.setIsSeenLoadingList.splice(this.setIsSeenLoadingList.findIndex((el) => el === item.id), 1)
      }
    },

    async getFormTemplate() {
      try {
        const data = await formTemplateApi.findFilledFormTemplateByFormTemplateId(this.$route.params.id)
        this.fields = new FieldList(data && data?.fields ? data.fields : {})
        this.formTemplate = new FormTemplate(data && data?.formTemplate ? data.formTemplate : {})
        // eslint-disable-next-line no-restricted-syntax
        for (const item of data.fields) {
          this.filtersTable.push({
            fieldTypeId: item.fieldType.id,
            formTemplateFieldId: item.id,
            fieldName: item.name,
            value: null,
          })
        }

        this.setHeader()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения описания формы')
      }
    },

    saveTableState() {
      try {
        const state = {
          list: this.list,
          pageNumber: this.pageNumber,
          lastPage: this.lastPage,
          filtersTable: this.filtersTable,
          timestamp: Date.now(),
        }
        sessionStorage.setItem(
          `filledFormState_${this.$route.params.id}`,
          JSON.stringify(state),
        )
      } catch (e) {
        console.warn('Не удалось сохранить состояние таблицы', e)
      }
    },

    restoreTableState() {
      try {
        const saved = sessionStorage.getItem(`filledFormState_${this.$route.params.id}`)
        if (!saved) return false

        const state = JSON.parse(saved)

        this.list = state.list
        this.pageNumber = state.pageNumber
        this.lastPage = state.lastPage
        this.filtersTable = state.filtersTable
        this.dataLoaded = true

        return true
      } catch (e) {
        console.warn('Не удалось восстановить состояние таблицы', e)
        return false
      }
    },

    setHeader() {
      this.tableHeaders = this.tableHeaders.slice(0, 5)

      this.fields.list.forEach((el) => {
        this.tableHeaders.push({
          text: el.name && el.name.slice(0, 20),
          value: `${String(el.id)}-${String(el.fieldType.id)}`,
          sortable: false,
          align: 'center',
          fieldTypeId: String(el.fieldType.id),
        })
      })
    },
    updateFilledFormList() {
      sessionStorage.removeItem(`filledFormState_${this.$route.params.id}`)
      sessionStorage.removeItem(`filledFormScroll_${this.$route.params.id}`)
      if (this.$refs?.table?.$el) {
        this.$refs.table.$el.scrollTo({ top: 0 })
      }

      this.lastPage = false
      this.pageNumber = 0

      this.getFilledFormList()
    },

    async getFilledFormList() {
      if (this.lastPage || this.delay) return
      this.tableLoading = true
      try {
        const currentFilters = this.filtersTable.filter((filter) => filter.value !== null && filter.value !== '').map((filter) => ({
          fieldTypeId: filter.fieldTypeId,
          formTemplateFieldId: filter.formTemplateFieldId,
          value: this.getCurrentValueForFilter(filter),
        }))

        const { content, last, totalElements } = await filledFormApi.findAllRowsByFormTemplateIdRegisteredByFilterNew(this.$route.params.id, this.pageNumber, currentFilters)
        if (this.pageNumber === 0) {
          this.list = []
        }

        this.lastPage = last
        this.total = totalElements

        if (content?.length) {
          content.forEach((obj) => {
            const body = {
              id: obj?.filledFormId,
              status: obj.status,
              sentTime: formatISODateTimeToText(obj.sentTime),
              isSeen: obj.isSeen,
              fieldValueId: {},
            }
            obj.values.forEach((el) => {
              if (el) {
                if (el.fieldType.id === FieldType.USER_FILE) {
                  body.fieldValueId[`${el.fieldId}-${el.fieldType.id}`] = el.id
                }
                body[`${el.fieldId}-${el.fieldType.id}`] = getCurrentValueForDisplay(el.value)
              }
            })

            if (this.list.findIndex((el) => el.id === body.id) < 0) {
              this.list.push(body)
            }
          })
        }
        this.pageNumber++
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения отчета')
      } finally {
        this.tableLoading = false
        setTimeout(() => {
          this.delay = false
        }, 300)
      }
    },

    async changeFilledFormStatus(statusId, item, comment = '') {
      try {
        this.tableLoading = true
        const filledFormChangeStatusDto = {
          comment,
          filledFormId: item.id,
          filledFormStatusNew: { id: statusId },
        }
        await filledFormApi.changeFilledFormStatus(filledFormChangeStatusDto)
        this.closeSendToRevisionDialog()
        await this.getFilledFormList()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка')
      } finally {
        this.tableLoading = false
      }
    },

    async printBadge(item) {
      try {
        this.badgeLoading = true
        this.currentLoadingBadgeId = item.id
        const badge = await badgeApi.uploadIndividualBadgePDF(item.id)
        printJS({ printable: badge.slice(badge.indexOf(',') + 1), type: 'pdf', base64: true })
      } catch (error) {
        const errorData = error.data instanceof Blob ? JSON.parse(await toText(error.data)) : error.data
        this.showErrorMessage(
          {
            ...error,
            data: errorData,
          },
          'Не удалось распечатать бейдж',
        )
      } finally {
        this.badgeLoading = false
        this.currentLoadingBadgeId = null
      }
    },

    show(item) {
      this.$router.push(`/spm/formConstructor/${item.id}`)
    },

    goToForm(item) {
      this.$router.push(`/spm/form/${this.$route.params.id}/adminEdit/${item.id}`)
    },

    edit(item) {
      this.$router.push(`/spm/formConstructor/${item.id}`)
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    openReportTemplatesListForDownloadDialog() {
      this.isOpenedReportTemplatesListForDownloadDialog = true
    },

    closeChoosingReportTemplatesListForDownloadDialog() {
      this.isOpenedReportTemplatesListForDownloadDialog = false
    },

    async saveFormTemplate(body) {
      try {
        this.saveBtnLoading = true
        const data = body.id ? await formTemplateApi.update(body) : await formTemplateApi.create(body)
        body.id ? this.formTemplateList.update(data) : this.formTemplateList.add(data)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async removeFilledForm() {
      try {
        this.removeLoading = true
        await filledFormApi.remove(this.selectedItem.id)
        const index = this.list.findIndex((el) => el.id === this.selectedItem.id)
        if (index >= 0) {
          this.list.splice(index, 1)
        }
        this.pageNumber -= 1
        this.lastPage = false
        await this.getFilledFormList()
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },

    async removeFormTemplate() {
      try {
        this.removeLoading = true
        await formTemplateApi.remove(this.selectedItem.id)
        this.formTemplateList.remove(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeConfirmDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.removeLoading = false
      }
    },

    setTableHeight() {
      this.$nextTick(() => {
        const footerHeight = 67
        if (this.$refs?.table) {
          const topHeight = this.$refs.table.$el.getBoundingClientRect().top
          this.$refs.table.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }

        if (this.$refs?.list) {
          const topHeight = this.$refs.list.$el.getBoundingClientRect().top
          this.$refs.list.$el.style.height = `${window.innerHeight - topHeight - footerHeight}px`
        }
      })
    },

    restoreScroll() {
      if (this.dataLoaded && this.$refs.table?.$el) {
        const saved = sessionStorage.getItem(`filledFormScroll_${this.$route.params.id}`)
        if (saved) {
          this.$nextTick(() => {
            this.$refs.table.$el.scrollTop = Number(saved)
          })
        }
      }
      this.restoredFromCache = false
    },

    tableScroll(event) {
      const el = event.target
      if (el.scrollHeight - el.clientHeight - el.scrollTop <= 10 && !this.tableLoading && !this.lastPage) {
        this.getFilledFormList()
      }
    },

    setFilters: debounce(async function debounceSetFilters(filters) {
      this.filters = cloneDeep(filters)
    }, 500),

    closeDialog() {
      this.dialog = false
      this.selectedItem = null
      this.isShowMode = false
    },

    closeSendToRevisionDialog() {
      this.sendToRevisionDialog = false
      this.selectedSendToRevisionItem = null
      this.selectedSendToRevisionStatus = null
    },

    closeConfirmDialog() {
      this.confirmDialog = false
      this.selectedItem = null
    },

    closeDownloadFilesDialog() {
      this.downloadFilesDialog = false
      this.selectedFieldValueId = null
    },
  },

  watch: {
    dataLoaded() {
      this.setTableHeight()
    },

    filters: {
      deep: true,
      async handler() {
        this.pageNumber = 0
        this.lastPage = false
        this.total = 0
        await this.getFormTemplateList()
      },
    },

    isShowFullNews() {
      this.setTableHeight()
    },
  },
}
</script>

<style scoped lang="scss">
.checkbox_margin-right_0 >>> .v-input--selection-controls__input {
  margin-right: 0 !important;
}

</style>
